import React from 'react';
import { renderList } from 'utils/async-list';
import { Column } from 'react-virtualized';

export const list = () => {
  const rowClickedUrl = id => '';
  const loadNextUrl = '/customer/documents.json';

  renderList(rowClickedUrl, loadNextUrl, renderColumns, {
    rowHeight: 60,
  });
};

const renderAction = ({ rowData }) => {
  return (
    <div>
      <a href={rowData.url} target="_blank" className="ui basic button">
        <i className="download outline icon" />
        Télécharger
      </a>
    </div>
  );
};

function renderColumns(width) {
  return [
    <Column
      key="file_id"
      dataKey="file_id"
      width={width / 16 * 3}
      cellRenderer={renderAction}
      disableSort
      label="Action"
    />,
    <Column
      key="fileName"
      dataKey="fileName"
      width={width / 16 * 7}
      label="Nom"
    />,
    <Column
      key="caseName"
      dataKey="caseName"
      width={width / 16 * 7}
      label="Chantier"
    />,
  ];
}



// WEBPACK FOOTER //
// ./src/modules/customer/documents.js